import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { trackEvent } from 'utils/eventTracking';
import Button from 'components/buttons/Button';
import { InfoTooltip } from 'components/v3';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import { addLocalMessage, fetchMessage } from 'store/modules/chat-messages';
import uuid from 'uuid';

import useMediaQuery from 'utils/mediaQueries';

const SummarizeInsightsButton = ({ answerId, isLlmDataAccessAllowed, username, summaryDetailsKey, t, dispatch }) => {
  const isMobile = useMediaQuery();
  const handleClick = () => {
    if (!isLlmDataAccessAllowed) {
      console.warn('Summarize insights clicked but LLM data access is not allowed.');
      return;
    }

    trackEvent('Summarize Insights Button Clicked', { answer: { id: answerId } });

    const summaryQuestionText = t(`${summaryDetailsKey}.prompt`);
    const localQuestionId = uuid();

    const otherParams = {
      referenceTo: {
        answerId: answerId // ID of the multi-step answer sequence to summarize
      },
      useSystemZero: true
    };

    const localMessage = addLocalMessage(username, summaryQuestionText);
    // display the question locally
    dispatch(localMessage);
    dispatch(fetchMessage(summaryQuestionText, localQuestionId, otherParams, t));
  };

  if (!isLlmDataAccessAllowed) {
    return null;
  }

  const buttonText = t(`${summaryDetailsKey}.button`);

  return (
    <InfoTooltip text={t(`${summaryDetailsKey}.tooltip`)}>
      <Button
        className="button-secondary"
        onClick={handleClick}
        showOnlyIcon={isMobile}
        text={buttonText}
        data-test="summarize-insights-button"
      >
        <TipsAndUpdatesIcon fontSize="small" style={{ fill: 'var(--yellow)' }} />
      </Button>
    </InfoTooltip>
  );
};

SummarizeInsightsButton.propTypes = {
  answerId: PropTypes.string,
  isLlmDataAccessAllowed: PropTypes.bool.isRequired,
  username: PropTypes.string.isRequired,
  summaryDetailsKey: PropTypes.string,
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    username: state.user.username
  };
}

export default withTranslation('veezoo')(connect(mapStateToProps)(SummarizeInsightsButton));
